<template>
  <div class="search-page">
    <ActNav></ActNav>
    <div class="search-wrapper">
      <header>站内搜索</header>
      <div class="divide"></div>
      <div class="input-wrapper">
        <input type="text" v-model="searchKey" @keyup.enter="handleSearch" />
        <button @click="handleSearch">
          <i class="el-icon-search"></i>
          搜索
        </button>
      </div>
      <div class="search-result">
        共约
        <span>{{searchRes.count}}</span>条结果
      </div>
      <ul class="search-content" v-if="searchRes.count && searchRes.count != 0">
        <li
          class="search-item"
          v-for="item in searchRes.searchArticle"
          :key="item.id"
          @click="getArticleInfo(item.id)"
        >
          <div class="item-left">
            <span>【{{item.category_name}}】</span>
            <span>{{item.title.slice(0,item.title.toLowerCase().indexOf(searchKey.toLowerCase()))}}</span>
            <span
              style="color:#c52e0f"
            >{{item.title.slice(item.title.toLowerCase().indexOf(searchKey.toLowerCase()),item.title.toLowerCase().indexOf(searchKey.toLowerCase())+searchKey.length)}}</span>
            <span>{{item.title.substr(item.title.toLowerCase().indexOf(searchKey.toLowerCase())+searchKey.length)}}</span>
          </div>
          <div class="item-right">{{item.createtime}}</div>
        </li>
      </ul>
      <div class="tip-box" v-if="searchRes.count == 0">
        <div class="tip-img"></div>
        <div class="tip-desc1">没有找到相关内容</div>
        <div class="tip-desc2">换一个词试试？</div>
      </div>
      <div class="search-footer" v-if="searchRes.count && searchRes.count != 0">
        <el-pagination
          background
          layout="pager, next"
          :current-page="searchRes.start_page"
          :total="searchRes.count"
          @current-change="currentPageClick"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ActNav from "@/components/ActNav";
import store from "@/store";
import Api from "@/api/searchApi";

// import { mapActions } from "vuex";
export default {
  components: {
    ActNav
  },
  props: {},
  data() {
    return {
      searchKey: "",
      searchRes: {
        count: null,
        searchArticle: [],
        start_page: null,
        total_page: null
      }
    };
  },
  watch: {
    $route(to, from) {
      to.path !== from.path ? this.routeChange(to.path.split("/")[2]) : "";
    }
  },
  created() {
    // 第一次进入页面拿到 搜索关键词和搜索结果填充
    this.searchKey = store.state.Search.searchKey;
    this.searchContent(this.searchKey, 1);
  },
  methods: {
    searchContent(key, page) {
      Api.getSearchContent(key, page)
        .then(res => {
          const { count, searchArticle, start_page, total_page } = res.data;
          this.searchRes.count = count;
          this.searchRes.searchArticle = searchArticle;
          this.searchRes.start_page = start_page;
          this.searchRes.total_page = total_page;
        })
        .catch(err => console.log(err));
    },
    routeChange(key) {
      store.commit("Search/searchKey", key);
      this.$router.go(0);
      this.searchContent(key, 1);
    },
    handleSearch() {
      if (this.searchKey) {
        this.$router.push(`/search/${this.searchKey}/${Math.random()}`);
      }
    },
    // 点击页数跳转
    currentPageClick(page) {
      this.backTop();
      this.searchContent(this.searchKey, page);
    },
    // 跳转到文章详情
    getArticleInfo(id) {
      // 1 是轮播图 0 是文章
      let { href } = this.$router.resolve({ path: `/info/0/${id}` });
      window.open(href, "_blank");
    },
    // 点击页数 返回顶部
    backTop() {
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("minireset.css");
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

.search-wrapper {
  width: 1200px;
  // height: 602px;
  margin: 0 auto 40px auto;
  padding: 32px 40px 40px 40px;
  background: #fff;
  box-sizing: border-box;
  header {
    @include font-style("PingFangSC-Semibold", 20px, rgba(197, 46, 15, 1), 600);
    line-height: 28px;
  }
  .divide {
    margin-top: 15px;
    width: 100%;
    height: 2px;
    background-color: #dbdbdb;
    border-left: 80px solid #c52e0f;
    box-sizing: border-box;
  }
  .input-wrapper {
    display: flex;
    margin-top: 40px;
    height: 50px;
    & > input {
      width: 1120px;
      padding-left: 11px;
      padding-right: 11px;
      background: rgba(242, 242, 242, 1);
      border: 1px solid rgba(219, 219, 219, 1);
      @include font-style("PingFangSC-Regular", 16px, rgba(58, 58, 58, 1), 400);
      line-height: 22px;
      outline: none;
    }
    & > button {
      width: 120px;
      padding: 0;
      border: none;
      background: rgba(204, 43, 27, 1);
      outline: none;
      @include font-style(
        "PingFangSC-Regular",
        20px,
        rgba(255, 255, 255, 1),
        400
      );

      line-height: 50px;
      & > i {
        margin-right: 7px;
        font-size: 20px;
      }
    }
    & > button:hover {
      cursor: pointer !important;
    }
  }
  .search-result {
    @include font-style("PingFangSC-Regular", 14px, rgba(58, 58, 58, 1), 400);
    line-height: 20px;
    margin-top: 10px;
    margin-left: 9px;
    margin-bottom: 17px;
    & > span {
      color: #c52e0f;
    }
  }
  .search-content {
    margin-bottom: 24px;
    .search-item {
      display: flex;
      line-height: 28px;
      padding-top: 14px;
      padding-bottom: 14px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #dbdbdb;
      box-sizing: border-box;
      .item-left {
        flex: 1;
        @include font-style(
          "PingFangSC-Regular",
          16px,
          rgba(58, 58, 58, 1),
          400
        );
        margin-right: 30px;
      }
      .item-right {
        @include font-style(
          "PingFangSC-Regular",
          14px,
          rgba(122, 122, 122, 1),
          400
        );
      }
    }
    :hover {
      cursor: pointer !important;
    }
  }
  .tip-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .tip-img {
      width: 200px;
      height: 170px;
      margin-top: 60px;
      background-image: url("../assets/tip.png");
      background-size: 100% 100%;
    }
    .tip-desc1 {
      margin-top: 30px;
      @include font-style("PingFangSC-Regular", 20px, rgba(58, 58, 58, 1), 400);
      line-height: 28px;
    }
    .tip-desc2 {
      margin-top: 6px;
      @include font-style(
        "PingFangSC-Regular",
        16px,
        rgba(136, 136, 136, 1),
        400
      );
      line-height: 22px;
    }
  }
}
</style>
<style lang="scss">
.search-footer {
  @mixin font-style($family, $size, $color, $weight) {
    font-family: $family;
    font-size: $size;
    color: $color;
    font-weight: $weight;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/search.vue